import notify from '../Style-guide/ToastMessage';
import handleBadResponse from './handleBadResponse';

const { REACT_APP_BACKEND_URL } = process.env;
const BASE_URL = REACT_APP_BACKEND_URL || 'http://localhost:9000';
// const BASE_URL = 'http://192.168.1.11:9000'; /// for local network testing

function buildUrl(url, params = {}, queryParams = {}) {
  // Clean up slashes
  let requestUrl = `${BASE_URL.replace(/\/$/, '')}/${url.replace(/^\//, '')}`;

  // Replace path params like :id
  Object.keys(params).forEach((key) => {
    if (requestUrl.includes(`:${key}`)) {
      requestUrl = requestUrl.replace(`:${key}`, encodeURIComponent(params[key]));
    } else {
      // eslint-disable-next-line no-console
      console.warn(`Parameter ":${key}" not found in URL: ${url}`);
    }
  });

  // Append query string if any
  const queryString = new URLSearchParams(queryParams).toString();
  if (queryString) {
    requestUrl += `?${queryString}`;
  }

  return requestUrl;
}

async function makeRequest(
  method,
  url,
  { params = {}, queryParams = {}, data = null } = {}
) {
  const requestUrl = buildUrl(url, params, queryParams);
  const controller = new AbortController();

  const timeout = setTimeout(() => {
    controller.abort();
    notify.error('Request timed out.');
  }, 10000);

  const isFormData = data instanceof FormData;
  let headers;
  let body;

  if (data) {
    if (isFormData) {
      headers = undefined;
      body = data;
    } else {
      headers = { 'Content-Type': 'application/json' };
      body = JSON.stringify(data);
    }
  } else {
    headers = undefined;
    body = undefined;
  }

  const response = await fetch(requestUrl, {
    method,
    headers,
    credentials: 'include',
    body,
    signal: controller.signal,
  });

  clearTimeout(timeout);
  await handleBadResponse(response);

  return response.json();
}

// GET request
export function getData(url, params = {}, queryParams = {}) {
  return makeRequest('GET', url, { params, queryParams });
}

// POST request
export function sendData(url, data, params = {}, queryParams = {}) {
  return makeRequest('POST', url, { data, params, queryParams });
}

// PUT request
export function updateData(url, data, params = {}, queryParams = {}) {
  return makeRequest('PUT', url, { data, params, queryParams });
}

// DELETE request
export function deleteData(url, data, params = {}, queryParams = {}) {
  return makeRequest('DELETE', url, { data, params, queryParams });
}
